import Chart from "chart.js/auto";
import { Line } from "react-chartjs-2";
import { useState, useEffect, useRef } from "react";

const LineCharts = () => {
  const chartRef = useRef();
  const [gradientValue, setGradientValue] = useState("");
  useEffect(() => {
    const ctx = chartRef.current.canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, "#84d1fea7");
    gradient.addColorStop(1, "#ffffff00");
    setGradientValue((prev) => gradient);
  }, []);
  return (
    <Line
      ref={chartRef}
      data={{
        labels: [], // x axis
        datasets: [
          {
            type: "line",
            label: "Current",
            fill: false,
            backgroundColor: gradientValue || "#0183d0",
            data: [],
            borderColor: "#0183d0",
            radius: 1,
            borderWidth: 1,
            pointBorderWidth: 1,
            tension: 0.4,
          },
          {
            type: "line",
            label: "Voltage",
            fill: false,
            backgroundColor: "#ff634730",
            data: [],
            borderColor: "tomato",
            radius: 1,
            borderWidth: 1,
            pointBorderWidth: 1,
            tension: 0.4,
          },
        ],
      }}
      options={{
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: "bottom",
          },
          title: {
            display: true,
          },
          tooltip: {
            // callbacks: {
            //   label: function (tooltipItem, data) {
            //     return numFormtter(parseInt(tooltipItem.parsed.y));
            //   },
            // },
          },
        },
        scales: {
          x: {
            display: false,
            grid: {
              display: false,
            },
          },
          y: {
            display: true,
            grid: {
              display: true,
              borderDash: [10],
              borderDashOffset: 20,
              borderWidth: 0,
              color: "#eee",
            },
          },
        },
      }}
    />
  );
};

export default LineCharts;
